module.exports = __webpack_public_path__ + "static/media/light-rain-cloud-weather_200_transparent.43ee7eab.gif";